<div id="settings-users-management" class="container-fluid do-not-expand-beyond-router-outlet-wrapper pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH USERS -->

        <div class="col-sm-12 col-md-4 left-column">
            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters mb-3">
                        <div class="col-sm-12">
                            <button mat-flat-button
                                    color="accent"
                                    class="full-width"
                                    (click)="createUser()">
                                {{ 'user_management.btn.create' | translate | uppercase }}
                            </button>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ 'common.label.search' | translate }}</mat-label>
                                <input type="text" matInput
                                       [(ngModel)]="filter.searchText">
                                <button mat-button
                                        matSuffix mat-icon-button
                                        aria-label="'common.label.search' | translate"
                                        *ngIf="filter.searchText"
                                        (click)="filter.searchText = ''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>

                    <alphabet-search [(letter)]="filter.letter"></alphabet-search>

                    <div class="row no-gutters license-container">
                       <div class="col-sm-6">
                           <span>{{ licenseInfo }}</span>
                       </div>
                        <div class="col-sm-6">
                            <span class=" state-filter">{{ selectedStateFilter.trans | translate }} ({{selectedStateFilter.amount()}})</span>
                            <i class="dr-fa-icon fas fa-sort-down state-filter-btn"
                               [matMenuTriggerFor]="stateFilterMenu">
                            </i>
                        </div>

                        <mat-menu #stateFilterMenu="matMenu">
                            <mat-list>
                                <ng-container *ngFor="let stateFilter of stateFilters">

                                    <mat-list-item class="state-filter-item"
                                                   [ngClass]="{'active': selectedStateFilter === stateFilter}"
                                                   (click)="setStateFilter(stateFilter)">
                                        <h4 mat-line>{{ stateFilter.trans | translate }} ({{stateFilter.amount()}})</h4>
                                    </mat-list-item>

                                    <mat-divider *ngIf="stateFilter.dividerBelow" class="mb-2"></mat-divider>

                                </ng-container>
                            </mat-list>
                        </mat-menu>
                    </div>

                    <!-- Below template is passed on to the action list to replace the default appearance -->
                    <ng-template #customActionListTemplate
                                 let-user="data">
                        <span class="action-list-display-name" *ngIf="filter.filteredArray">{{ user.actionListDisplayName | translate }}

                            <!-- INVITED / NOT INVITED ICONS -->

                            <i class="dr-fa-icon dr-fa-icon-action-list fas fa-envelope-open-text dr-color-blue"
                               matTooltip="{{ 'client_user.state.not_invited' | translate }}"
                               *ngIf="!user.locked && (user.state === ClientUserState.NOTINVITED || user.state === ClientUserState.TEMPORARY)">
                            </i>

                            <i class="dr-fa-icon dr-fa-icon-action-list fas fa-envelope dr-color-blue"
                               matTooltip="{{ 'client_user.state.invited' | translate }}"
                               *ngIf="!user.locked && user.state === ClientUserState.INVITED">
                            </i>

                             <i class="dr-fa-icon dr-fa-icon-action-list fas fa-lock dr-color-blue"
                                matTooltip="{{ 'client_user.state.locked' | translate }}"
                                *ngIf="user.locked && user.state !== ClientUserState.INVITED && user.state !== ClientUserState.TEMPORARY">
                            </i>

                            <!-- ACTIVE / INACTIVE ICONS -->

                            <i class="dr-fa-icon dr-fa-icon-action-list fas fa-check"
                               matTooltip="{{ 'client_user.state.active' | translate }}"
                               *ngIf="!user.inactive">
                            </i>

                            <i class="dr-fa-icon dr-fa-icon-action-list fas fa-ban"
                               matTooltip="{{ 'client_user.state.inactive' | translate }}"
                               *ngIf="user.inactive">
                             </i>
                        </span>

                    </ng-template>

                    <action-list *ngIf="filter.filteredArray"
                                 class="action-list"
                                 [idPrefix]="idPrefix"
                                 [items]="finalFiltered"
                                 [selected]="selectedUser"
                                 [identifier]="'id'"
                                 [options]="actionListOptions"
                                 [template]="customActionListTemplate"
                                 (select)="selectUser($event)"
                                 (copy)="copyUser($event)"
                                 (delete)="deleteUser($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED USER -->


        <div class="col-sm-12 col-md-8 right-column">

            <mat-card>
                <mat-card-content>
                    <client-user *ngIf="selectedUser"
                                 [idPrefix]="idPrefix"
                                 [client]="client"
                                 [roles]="clientRoles"
                                 [assignments]="userAssignments"
                                 [bananaBox]="selectedUser"
                                 (bananaBoxChange)="updateInList($event)"
                                 (canceled)="cancelEdit()">
                    </client-user>
                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>
